import type {
  EmergencyTimelineEntry,
  EmergencyTimelineFirestoreRecord,
} from '@src/models/interfaces/emergency.interface';
import { DateUtil } from '@src/packages/utils/dates';
import { resolveUserDisplayName } from '@src/packages/utils/user';

import { asRecord, asString } from './emergencyMapper.utils';

export class EmergencyTimelineMapper {
  static fromFirestore(record: EmergencyTimelineFirestoreRecord): EmergencyTimelineEntry {
    const payload = asRecord(record.payload);
    const actor = asRecord(record.actor);
    const actorName = resolveUserDisplayName(
      {
        firstName: asString(actor.firstName),
        lastName: asString(actor.lastName),
        displayName: asString(
          record.actorDisplayName,
          asString(actor.displayName, asString(payload.actorName)),
        ),
      },
      '',
    );
    return {
      id: record.id,
      incidentId: asString(record.incidentId),
      type: asString(record.type),
      // activationMerged names the emergency type folded into this incident.
      message: asString(
        payload.text,
        asString(payload.reason, asString(payload.emergencyTypeName, asString(record.type))),
      ),
      ...(asString(record.actorId) && { actorId: asString(record.actorId) }),
      ...(asString(record.actorRole) && { actorRole: asString(record.actorRole) }),
      actorName,
      ...(asString(payload.context) && { contextText: asString(payload.context) }),
      createdAt: DateUtil.toDateOrNull(record.createdAt),
    };
  }
}
